<template>
  <div id="hrms1ax">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms1axIndex"
            :columnEvent="columnEvent"
            :maxRowspan="maxRowspan.index"
            :csvExportDisp="true"
            searchBoxAlias="hrms1ax"
            :callSearchEvent="callSearchEvent" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms1ax/mutation-types'
import moment from 'moment'

export default {
  name: 'hrms1ax',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      searchIndex: {
        dteworkst: moment().format('01/01/YYYY'),
        dteworken: moment().format('DD/MM/YYYY')
      },
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHrms1axColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS1AX_INDEX_DISP,
      columns: types.GET_HRMS1AX_COLUMNS,
      labels: types.GET_HRMS1AX_LABELS,
      index: types.GET_HRMS1AX_INDEX,
      maxRowspan: types.GET_HRMS1AX_MAX_ROWSPAN
    })
  },
  methods: {
    callSearchEvent () {
      if (this.searchIndex.codempid !== '') {
        this.searchIndex.codcomp2 = ''
        this.searchIndex.codcalen = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS1AX_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS1AX_PAGE,
      receivedHrms1axColumnsLabels: types.RECEIVED_HRMS1AX_COLUMNS_LABELS,
      receivedHrms1axIndex: types.RECEIVED_HRMS1AX_INDEX
    })
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?90555fd2